import { Text } from '@consta/uikit/Text'
import { changeProjectState, useAppDispatch } from '@core/core/store'
import { getProjectDataAnalyticParams } from '@core/core/utils'
import { DialogModal } from '@library/components'
import type { UseBooleanFlagApi } from '@library/hooks'
import { forwardRef } from 'react'

import { getModalContent } from './constants'
import css from './PublishingModal.css'
import type { PublishingModalProps } from './types'

export const PublishingModal = forwardRef<UseBooleanFlagApi, PublishingModalProps>(
  function PublishingModal({ projectId, name, state, projectType }, ref) {
    const dispatch = useAppDispatch()
    const { prompt, activeButtonText, dataAnalyticsId, newState } = getModalContent(
      state ?? 'Private',
      name,
    )

    return (
      <DialogModal
        ref={ref}
        className={css.modal}
        cancelLabel="Отмена"
        submitLabel={activeButtonText}
        submitButtonProps={{
          'data-analytics-id': dataAnalyticsId,
          'data-analytic-params': getProjectDataAnalyticParams(name, projectType),
        }}
        initialValue={undefined}
        onEnd={({ performAction }) => {
          if (performAction) {
            dispatch(changeProjectState({ projectId, newState }))
          }
        }}>
        {() => {
          return (
            <Text size="xs" view="secondary">
              {prompt}
            </Text>
          )
        }}
      </DialogModal>
    )
  },
)
